export class TrocaSenha
{
    public IdentificadorUsuario: number=null;
    public SenhaAtual: string=null;
    public NovaSenha: string = null;
    public ConfirmacaoSenha: string=null;
}